import BaseBehavior from '../../../framework/base/base';
import { screenSmallerThan } from '../../../shared/utilities/screenSize';
// import { destroyBehaviors, initBehaviors } from '../../../shared/utilities/behaviors';
import { config, trackSearch } from './dynamic-pricing-tracking';
import { objectToQueryString } from '../../../shared/utilities/objectToQueryString';
import {
	prepareContentForTable,
	getErrorTemplate,
	checkAndRenderForNoResult
} from './dynamic-pricing2-utils';

const dataValues = {
	etfTableIndicator: 'ETF'
};
export default class DynamicPricing2 extends BaseBehavior {
	constructor(element) {
		super(element);
		this.isETFTable = element.dataset.tableType === dataValues.etfTableIndicator;
		this.isExchangeColumn = Boolean(element.dataset.exchangeColumnId);
		this.initDomCache();
		this.status = 'idle'; // loading , success , error
		this.cols = [];
		this.query = {
			current: '',
			lastValid: '',
			url: ''
		};
		this.priceFilter = {
			text: 'default',
			value: []
		};
		this.records = {
			total: 0, // total available records
			skip: 0, // index from which records needs to be fetched
			top: 0 // no of records to be fetched in each call
		};
		this.cachedResponse = {};
		this.tradeCol = this.dom.dpContainer.querySelector('th[data-columntype="TradeColumnType"]');
		this.showInfoCol =
			this.dom.dpContainer.querySelector('th[data-columntype="InfoColumnType"]') !== null;
		this.isSearchResultPageComponent = element.closest('[data-qa="search-result-page"]');

		this.init();
		this.addEventListeners();
		this.filterIds = Array.from(element.querySelectorAll('.dropdown-check-list')).map(
			item => item.dataset.dropdownId
		);
		this.filterIdsClone = [...this.filterIds];
		// subscribe for dropdown change events
		this.addSubscriptions();
	}

	init() {
		const {
			serviceuicurl,
			servicekeywordurl,
			servicedomain,
			commissiongroupids,
			uics,
			assetids,
			namecategoryid,
			infoMobiletext,
			culture,
			database,
			environment,
			infoLabel
		} = this.dom.dpContainer.dataset;
		this.config = {
			serviceuicurl,
			servicekeywordurl,
			servicedomain,
			params: {
				uics,
				assetids,
				namecategoryid,
				commissiongroupids,
				infoMobiletext,
				infoLabel,
				getinfodata: this.showInfoCol,
				db: database,
				lang: culture,
				env: environment
			}
		};
		// update col header as per pricing plan filter
		this.prepareHeaderInfo();

		if (assetids && assetids.startsWith('asset-')) {
			this.showStaticAssetMsg(assetids);
			this.dom.dpContainer.classList.remove('dynamic-pricing__search--loading');
		} else {
			const url = this.prepareURL('');
			if (url) {
				// load skeleton loader
				this.fetchInstrumentRows(url)
					.then(response => {
						this.status = 'success';

						const { Data } = response;
						// caching initial response
						if (
							(!this.isETFTable && (Data === null || Data.length === 0)) ||
							(this.isETFTable && Data === null)
						) {
							throw new Error('Empty Response on initial load');
						} else if (this.isETFTable && Data.length === 0) {
							this.renderContent(response);
						}
						if (Data.length > 0) {
							// check here in case of etf
							this.cachedResponse[this.priceFilter.text] = this.filterEmptyRows(response);
						}
						this.updateTotalRecordsAndUrl(response, url);
						Data?.length > 0 && this.renderContent(response);
					})
					.catch(() => {
						this.status = 'error';
						this.handleErrorState();
					})
					.finally(() => {
						this.dom.dpContainer.classList.remove('dynamic-pricing__search--loading');
					});
			}
		}
	}

	updateTotalRecordsAndUrl(response, url) {
		this.records.total =
			this.isETFTable && response.HasMoreResults ? response.TotalCount : this.records.total;
		this.query.url = this.isETFTable ? url : this.query.url;
	}

	showStaticMessage(staticMarkup) {
		this.dom.desktopRows.innerHTML = '';
		this.dom.mobileRows.innerHTML = '';

		const mobileRow = document.createElement('div');
		mobileRow.innerHTML = staticMarkup;

		const row = document.createElement('tr');
		const col = document.createElement('td');
		col.colSpan = 15;
		col.innerHTML = staticMarkup;
		row.appendChild(col);

		this.dom.desktopRows.appendChild(row);
		this.dom.mobileRows.appendChild(mobileRow);

		// remove show more
		this.dom.loadMore && this.dom.loadMore.classList.add('v2-hidden');
	}

	showStaticAssetMsg(assetids) {
		const element = document.getElementById(assetids);
		const assetMarkup = element.innerHTML;

		this.showStaticMessage(assetMarkup);
	}

	handleErrorState() {
		const { errorTitle = '', errorMsg = '' } = this.dom.dpContainer.dataset;
		const errorMarkup = getErrorTemplate(this, errorTitle, errorMsg);

		this.showStaticMessage(errorMarkup);
	}

	prepareHeaderInfo() {
		/* eslint-disable indent */
		/* eslint-disable prettier/prettier */
		this.cols = [];
		let selectedPriceFilter = '';
		const srpComp = document.querySelector('[data-qa="search-result-page"]');
		let srpInstrumentSection; let srpInstrumentSectionLi; let srpInstrumentSectionPf; let srpInstrumentSectionLiPf ;
		if(srpComp) {
			srpInstrumentSection = srpComp?.querySelector('[data-ref="search-result-page__instrument_section"]');
			srpInstrumentSectionPf = srpInstrumentSection?.querySelector(
				'div[data-ref="search-result-page__priceFilter"]');
			srpInstrumentSectionLi = srpComp?.querySelector('[data-ref="search-result-page__instrument_section_li"]');
			srpInstrumentSectionLiPf = srpInstrumentSectionLi.querySelector(
				'div[data-ref="search-result-page__priceFilter"]');
		}
		// In case of DP2 inside SRP, first it will try to find value from instrument section price filter, else instrument section li price filter.
		const priceFilter = srpComp ? (srpInstrumentSectionPf || srpInstrumentSectionLiPf) : this.dom.priceFilter ;

		/* put condition for ETF here since price filter doesn't exist in etf, i think it will bve hard coded and prepare value for this.priceFilter.text 
			and this.priceFilter.value */
		if (priceFilter) {
			const selected = priceFilter?.querySelector('.anchor-text--optional');
			selectedPriceFilter = selected.dataset.value;
			this.priceFilter.text = selected.innerText?.trim();
		} else {
			selectedPriceFilter = this.dom.dpContainer.dataset.commissiongroupids;
		}

		this.priceFilter.value = selectedPriceFilter.split(',');

		this.dom.dpContainer
			.querySelectorAll('th[data-columntype="CommissionColumnType"]')
			.forEach(col => {
				const colId = col.dataset.commissiongroupid;

				const showCol = this.priceFilter.value.find(val => val === colId);
				if (showCol) {
					const obj = {
						Label: col.querySelector('.label').innerText?.trim(),
						Name: colId,
						ShowInfo: col.querySelector('.dynamic-pricing__headerIcon') !== null
					};
					this.cols.push(obj);
					col.classList.remove('v2-hidden');
				} else {
					col.classList.add('v2-hidden');
				}
			});
	}

	prepareURL(keywords) {
		const searchParams = { ...this.config.params };
		if (keywords || (!keywords && this.isETFTable)) {
			const { top = 0, skip = 0 } = this.dom.searchContainer.dataset;
			searchParams.uics = '';
			searchParams.namecategoryid = this.dom.dpContainer.dataset.namecategoryidforsearch;
			searchParams.keywords = keywords;
			searchParams.top = top;
			searchParams.skip = skip;
			this.records.top = Number(top);
			this.records.skip = Number(skip);
		}
		if(this.isETFTable) {
			this.updateSearchParamsForETF(searchParams);
		}
		else {
			this.updateSearchParamsForNonETF(searchParams, keywords);
		}
		
		if (this.dom.countryFilter) {
			const val =
				(this.dom.proficiencyFilter &&
					this.dom.proficiencyFilter.querySelector('.anchor-text--optional').dataset.value) ||
				'retail';
			if (val.toLowerCase() === 'retail') {
				const countryVal =
					this.dom.countryFilter.querySelector('.anchor-text--optional').dataset.value || '';
				searchParams.marketcode = countryVal;
			}
		}
    
    const url = searchParams.uics ? this.config.serviceuicurl : this.config.servicekeywordurl;

    return url ? `${url}?${objectToQueryString(searchParams)}` : null;
	}

	updateSearchParamsForETF(searchParams) {
			const minKeys = this.dom.searchContainer ? Number(this.dom.searchContainer.dataset.min) : 0;
			// removing unnecessary properties in case of etf table
			delete searchParams?.uics;
			const val = this.dom.assetsFilter.querySelector('.anchor-text--optional').dataset.value || '';
			searchParams.assetids = val;
			// add code for exchange filter
			searchParams.exchangeIds = this.dom.exchangeFilter?.querySelector('.anchor-text--optional').dataset.value || '';
			searchParams.keywords = (searchParams.keywords.length < minKeys) ? "" : searchParams.keywords;
	}

	updateSearchParamsForNonETF(searchParams,keywords) {
		if (this.dom.assetsFilter && keywords) {
			const val = this.dom.assetsFilter.querySelector('.anchor-text--optional').dataset.value || '';
			searchParams.assetids = val;
		}
		if (this.dom.priceFilter) {
			const val = this.dom.priceFilter.querySelector('.anchor-text--optional').dataset.value || '';
			searchParams.commissiongroupids = val;
		}
	}

	

	subscriptionResetDone(filterId, dpElement) {
		if(dpElement === this.element) {
			const index = this.filterIdsClone.findIndex(filter => filter === filterId);
			this.filterIdsClone.splice(index,1);
			if(!this.filterIdsClone.length) {
				this.dom.searchBox.value = '';
				this.query.current = '';
				this.query.lastValid = '';
				this.dom.clearSearch.classList.add('v2-not-visible');
				this.init();
			}
		}
	}

	addSubscriptions() {
		this.subscribe('reset-done', ({filterId, dpElement}) => {
			this.subscriptionResetDone(filterId, dpElement);
		});
		if (!this.isSearchResultPageComponent) {
			this.subscribe(`/cb-dropdown/change`, data => {
				const { guid } = this.dom.dpContainer.dataset;
				if (
					data.dropdownId &&
					guid === data.targetID &&
					(data.dropdownId === 'assetsFilter' ||
						data.dropdownId === 'priceFilter' ||
						data.dropdownId === 'proficiencyFilter' ||
						data.dropdownId === 'countryFilter' || data.dropdownId === 'exchangeFilter')
				) {
					this.query.lastValid = '';
					if(this.isETFTable) {
						this.triggerSearch(data.dropdownId, true);
					}
					else {
						this.triggerSearch(data.dropdownId);
					}
				}
			});
		}

		// subscribe to changes from search result page
		this.subscribe('/search-result/updateresults', ({ html, extraData }) => {
			this.renderContent(html, false, extraData);
		});
		this.subscribe('/search-result/openInfoPopup', data => {
			this.originSourceDP = data.source;
			this.handleContainerClick(data.event, this.originSourceDP);
		});

		this.subscribe('/search-result/loadmore', data => {
			this.records.skip = data.skip;
			this.records.top = data.top;
			this.query.url = data.url;
			this.query.current = data.query;
			this.originSourceDP = data.source;
			this.handleContainerClick(data.event, this.originSourceDP);
		});
		this.subscribe('/search-result/show-static-message-dp', data => {
			this.showStaticAssetMsg(data.assetId);
		});
		this.subscribe('dynamic-pricing/prepare-header-info', () => {
			this.prepareHeaderInfo();
		});
		this.subscribe('clean-srp-events', () => {
			this.unsubscribe('/search-result/loadmore');
			this.unsubscribe('/search-result/openInfoPopup');
		});
	}

	addEventListeners() {	
		this.addEventListener(this.dom.dpContainer, 'click', e => {
			this.handleContainerClick(e, 'DynamicPricing');
		});

		this.addEventListener(this.dom.filters, 'click', e => {
			this.handleContainerClick(e, 'DynamicPricing');
		});

		const handleSearch = () => {
			if (this.dom.searchBox.value.length === 0) {
				this.resetSearch();
			} else {
				this.triggerSearch();
			}
		};

		// events for searchBox
		if (this.dom.searchBox) {
			let timer = null;
			this.addEventListener(this.dom.searchBox, 'keydown', () => {
				clearTimeout(timer);
				timer = setTimeout(handleSearch, 500);
			});

			this.addEventListener(this.dom.searchBox, 'focus', () => {
				this.dom.searchContainer.classList.add('dynamic-pricing__search--active');
			});

			this.addEventListener(this.dom.searchBox, 'blur', () => {
				this.dom.searchContainer.classList.remove('dynamic-pricing__search--active');
			});

			this.addEventListener(this.dom.clearSearch, 'click', () => {
				this.resetSearch();
				this.dom.searchBox.focus();
			});
		}
	}

	filterQuery(txt) {
		// eslint-disable-next-line
		const regEx = /^(?:[a-zA-Z0-9][a-zA-Z0-9 :\-&.()%]*)?$/;
		// Regex will allow only alphanumeric and  special chars: -&)(.% in between
		if (!regEx.test(txt)) {
			return null;
		}
		const query = txt.trim();
		return query.toLowerCase();
	}

	
	beforeTriggerSearch(filterType, keywords) {
		if (
			filterType === 'priceFilter' ||
			filterType === 'proficiencyFilter' ||
			filterType === 'countryFilter'
		) {
			this.prepareHeaderInfo();
		}

		if (this.dom.searchBox && keywords !== '') {
			this.dom.clearSearch.classList.remove('v2-not-visible');
		}
		const refineMessage = this.element.querySelector('.etf-refine-message');
		refineMessage?.classList.add('v2-hidden');
	}

	// eslint-disable-next-line
	checkForNoSearch(keywords,minKeys,isSearch,filterType, triggeredFromETFDropdowon) {
		if (!this.isETFTable && isSearch && (filterType === '' || filterType !== 'priceFilter')) {
			return true;
		}
		if(this.isETFTable && !triggeredFromETFDropdowon && keywords && keywords.length < minKeys) {
			return true;
		}
		
	}

	triggerSearch(filterType = '', triggeredFromETFDropdowon = false) {
		const searchParams = { ...this.config.params };
		const minKeys = this.dom.searchContainer ? Number(this.dom.searchContainer.dataset.min) : 0;
		const keywords = this.dom.searchBox ? this.filterQuery(this.dom.searchBox.value) : '';
		this.query.current = keywords;
		// not searching for chars when not req
		const isSearch =
			!keywords || keywords.length < minKeys || this.query.current === this.query.lastValid;
		if(this.checkForNoSearch(keywords,minKeys,isSearch,filterType, triggeredFromETFDropdowon)) {
			return;
		}
		this.beforeTriggerSearch(filterType, keywords);

		let assetFilterVal = '';
		if (this.dom.assetsFilter && (keywords || this.isETFTable)) {
			assetFilterVal =
				this.dom.assetsFilter.querySelector('.anchor-text--optional').dataset.value || '';
		} else if (
			isSearch &&
			(filterType === 'priceFilter' ||
				filterType === 'proficiencyFilter' ||
				filterType === 'countryFilter')
		) {
			assetFilterVal = searchParams.assetids;
		}
		
		if (assetFilterVal.startsWith('asset-') && !assetFilterVal.includes(',')) {
			this.showStaticAssetMsg(assetFilterVal);
			this.dom.dpContainer.classList.remove('dynamic-pricing__search--loading');
			return;
		}

		// track instrument search

		const obj = {
			term: keywords,
			type: config.SEARCH_TYPE_INSTRUMENT,
			instrument: config.SEARCH_NO_INSTRUMENT,
			asset: this.dom.assetsFilter?.innerText || config.SEARCH_DEFAULT_FILTER
		};
		trackSearch(obj);

		// load skeleton loader
		this.dom.dpContainer.classList.add('dynamic-pricing__search--loading');

		// trigger Search
		const url = this.prepareURL(keywords);
		this.status = 'idle';
		this.fetchInstrumentRows(url)
			.then(response => {
				this.processAfterResponse(response, url);
			})
			.catch(() => {
				this.status = 'error';
				this.handleErrorState();
			})
			.finally(() => {
				this.dom.dpContainer.classList.remove('dynamic-pricing__search--loading');
			});
	}

	processAfterResponse(response, url) {
		this.status = 'success';
		this.query.lastValid = this.query.current;
		this.query.url = url;
		if ((this.isETFTable && response.Data === null) || ((!this.isETFTable && (response.Data === null || response.Data.length === 0)) && this.query.current === '')) {
			throw new Error('Error in fetching records');
		}
		else if(this.isETFTable && response.Data.length === 0) {
			// show no result 
			this.renderContent(response);
			return;
		}

		if (!this.cachedResponse[this.priceFilter.text] && this.query.current === '') {
			this.cachedResponse[this.priceFilter.text] = this.filterEmptyRows(response);
		}

		this.records.total = response.TotalCount;
		this.renderContent(response);
	}

	resetSearch() {
		this.dom.searchBox.value = '';
		this.query.current = '';
		this.query.lastValid = '';
		this.dom.clearSearch.classList.add('v2-not-visible');
		if(this.isETFTable) {
			this.init();
		}
		else if (this.cachedResponse[this.priceFilter.text]) {
			this.renderContent(this.cachedResponse[this.priceFilter.text]);
		} else {
			// trigger search with blank query text
			this.triggerSearch('priceFilter');
		}
	}

	closeHeaderInfoPopup(event) {
		if (event.target.dataset.behavior !== 'lightbox-trigger') {
			this.publish('/lightbox/close');
		}
	}

	openHeaderInfoPopup(targetId) {
		// TODO : bind different script template if separate modals required for pricing columns
		const template = document.getElementById(targetId);
		const div = document.createElement('div');
		div.innerHTML = template?.innerHTML || '';

		const title = div.querySelector('.dynamic-pricing-headerInfo__title');
		const cta = div.querySelector('.v2-dynamic-pricing-headerInfo__cta');
		cta && this.addEventListener(cta, 'click', this.closeHeaderInfoPopup.bind(this));

		this.publish('/lightbox/open', {
			type: 'html',
			cssClass: `dynamic-pricing-headerInfo-modal`,
			title,
			target: div
		});
	}

	handleLoadMoreClick(isSearchResultPage, source) {
		this.status = 'idle';
			if (isSearchResultPage && source === 'searchresultpage') {
				this.dom.loadMore = isSearchResultPage.querySelector('div[data-ref="dynamic-pricing2__loadMore"]');
			}
			this.dom.loadMore.querySelector('.loadMore').classList.add('v2-hidden');
			this.dom.loadMore.querySelector('.v2-loading-spinner').classList.remove('v2-hidden');

			// incremnt skip by count every click of show more btn
			this.records.skip += this.records.top;
			const url = this.query.url.replace(/skip=0/i, `skip=${this.records.skip}`);

			// If search result page exists but source is not search result page(may be DP2), then just return.
			if (isSearchResultPage && source !== 'searchresultpage') {
				return;
			}
			this.fetchInstrumentRows(url)
				.then(response => {
					this.processAfterShowMoreClickResponse(response, url);
				})
				.catch(error => {
					this.status = 'error';
					// eslint-disable-next-line no-console
					console.error(error);
					this.handleErrorState();
				})
				.finally(() => {
					this.dom.dpContainer.classList.remove('dynamic-pricing__search--loading');
				});
	}

	handleContainerClick(e, source) {
		const isSearchResultPage = e.target.closest(
			'[data-ref="search-result-page__result_container"]'
		);
		if (isSearchResultPage && source !== 'searchresultpage') {
			return;
		}
		// check if headerInfoClicked
		const headerIcon = e.target.closest('.dynamic-pricing__headerIcon');
		if (headerIcon) {
			const targetId = headerIcon.dataset.templateId;
			targetId && this.openHeaderInfoPopup(targetId);
			return;
		}

		// check if show more clicked
		if (e.target.dataset.type === 'loadMore') {
			this.handleLoadMoreClick(isSearchResultPage, source);
		}

		// get name and exchange of clicked row
		const row = screenSmallerThan('sm')
			? e.target.closest('.dynamic-pricing__row')
			: e.target.closest('tr');
		if (!row) return;
		const name = row.querySelector('.instrument__description-name')?.innerText || '';
		if (e.target.id.includes('trade')) {
			// track info popup click
			const obj = {
				term: this.dom.searchBox?.value || '',
				type: config.SEARCH_TYPE_TRADE,
				instrument: name,
				asset: this.dom.assetsFilter?.innerText || config.SEARCH_DEFAULT_FILTER
			};
			trackSearch(obj);
		}
		const icon = e.target.closest("span[data-qa='info-icon']");
		if (!icon) return;
		// get icon details
		const iconMatches = row
			.querySelector('.instrument__logo')
			.style.backgroundImage.match(/.*\/(.*).svg/);
		const flag = iconMatches ? iconMatches[1] : '';
		const type = row.querySelector('.instrument__logo').className.match(/[^--]*$/g)[0] || '';

		const exchange = row.querySelector('.instrument__description-exchange > span')?.innerText || '';
		const currency =
			row.querySelector('.instrument__description-exchange > span~span')?.innerText || '';
		const { url } = icon.dataset;
		const { errorTitle, errorMsg } = this.dom.dpContainer.dataset;
		const assetName = row.dataset?.assetName;
		const uic = row.dataset?.uic;
		this.updateMarkupTemplate({
			url,
			type,
			name,
			exchange,
			flag,
			currency,
			errorTitle,
			errorMsg,
			assetName,
			uic
		});

		// track info popup click
		const obj = {
			term: this.dom.searchBox?.value || '',
			type: config.SEARCH_TYPE_INFO,
			instrument: name,
			asset: this.dom.filter?.value || config.SEARCH_DEFAULT_FILTER
		};
		trackSearch(obj);

		this.publish('/lightbox/open', {
			type: 'id',
			cssClass: 'instrument-popup-box',
			target: this.dom.instrumentPopup.id
		});
	}

	processAfterShowMoreClickResponse(response, url) {
		this.status = 'success';
				this.query.lastValid = this.query.current;
				// eslint-disable-next-line no-console
				this.records.total = response.TotalCount;
				if (this.originSourceDP === 'searchresultpage') {
					this.renderContent(response, true, {
						top: +this.records.top,
						skip: +this.records.skip,
						total: this.records.total,
						url,
						source: 'searchresultpage'
					});
					this.publish('updated-DPdata-ForSRP', {
						top: +this.records.top,
						skip: +this.records.skip,
						total: this.records.total
					});
				} else {
					this.renderContent(response, true);
				}
	}

	updateMarkupTemplate(data) {
		const element = this.dom.instrumentPopup;
		let markup = element.innerHTML;
		// loop thru payload keys to and update the data attr.
		Object.keys(data).forEach(key => {
			const value = data[key];
			const regEx = new RegExp(`data-${key}="[^"]*"`, 'g');
			markup = markup.replace(regEx, `data-${key}="${value}"`);						
		});

		element.innerHTML = markup;
	}

	getColumns(data) {
		if (!data || data.length === 0) return [];
		data.forEach(({ PricingPlans }, index) => {
			const detailedPlans = this.cols.map(col => {
				const column = PricingPlans.find(ele => ele.Name === col.Name);
				if (column) {
					column.Label = col.Label;
					column.ShowInfo = col.ShowInfo;
				}
				return column;
			});
			data[index].PricingPlans = detailedPlans;
		});
		return data;
	}

	filterEmptyRows(response) {
		const insData = response.Data;
		const data = this.getColumns(insData);
		const filteredData = data.filter(row =>
			row.PricingPlans.some(col => col.Value || col.SubValue)
		);
		return { ...response, Data: filteredData };
	}

	settingQueryParamsForSRP(response, extraData) {
		if (Object.keys(extraData).length) {
			this.records.top = extraData.top ? extraData.top : 0;
			this.records.skip = extraData.skip ? extraData.skip : 0;
			this.records.total = response.TotalCount;
			this.query.url = extraData.url ? extraData.url : '';
			this.query.current = extraData.query ? extraData.query : this.query.current;
		}
	}

	setStartIndex(index, startIndex) {
		let srtInd = null;
		if (index !== 0 && startIndex === null) {
			srtInd = 0;
		} else srtInd = index;
		return srtInd;
	}

	

	renderContent(response, loadMore = false, extraData = {}) {
		this.settingQueryParamsForSRP(response, extraData);
		const insData = response.Data;
		const data = this.getColumns(insData);
		const desktopFrag = document.createDocumentFragment();
		const mobileFrag = document.createDocumentFragment();
		let startIndex = null;
		
		data.forEach((item, index) => {
			// desktop markup
			// filtering non empty rows
			const showRow = item.PricingPlans.some(col => col.Value || col.SubValue);
			if (showRow || this.query.current !== '') {
				startIndex = this.setStartIndex(index, startIndex);
				prepareContentForTable(this, item, index, startIndex, loadMore, desktopFrag, mobileFrag);
			}
		});
		const srpComp = extraData?.source === 'searchresultpage' ? document.querySelector('[data-qa="search-result-page"]') : null;
		
		if (!loadMore) {
			if(srpComp) {
				const srpDesktopRows =srpComp.querySelector('div[data-ref="search-result-page__result_container"] tbody[data-ref="dynamic-pricing2__desktopRows"]');
				srpDesktopRows.innerHTML = '';
				const srpMobileRows =srpComp.querySelector('div[data-ref="search-result-page__result_container"] div[data-ref="dynamic-pricing2__mobileRows"]');
				srpMobileRows.innerHTML = '';
			}
			else {
				this.dom.desktopRows.innerHTML = '';
				this.dom.mobileRows.innerHTML = '';
			}
		} else {
			this.dom.loadMore.querySelector('.v2-loading-spinner').classList.add('v2-hidden');
			// this.dom.loadMore.querySelector('.loadMore').classList.remove('v2-hidden');
		}

		/* when empty rows on load */
		if (!this.isETFTable && startIndex === null && this.query.current === '') {
			this.handleErrorState();
			return;
		}

		// check for no records fetched, not showing for loadmore when we get limited records
		const isNoResult = checkAndRenderForNoResult(this, data, loadMore, desktopFrag, mobileFrag);
		if(srpComp) {
			const srpDesktopRows =srpComp?.querySelector('div[data-ref="search-result-page__result_container"] tbody[data-ref="dynamic-pricing2__desktopRows"]');
			srpDesktopRows.appendChild(desktopFrag);
			const srpMobileRows =srpComp.querySelector('div[data-ref="search-result-page__result_container"] div[data-ref="dynamic-pricing2__mobileRows"]');
			srpMobileRows.appendChild(mobileFrag);
			this.dom.loadMore = srpComp?.querySelector('div[data-ref="search-result-page__result_container"] div[data-ref="dynamic-pricing2__loadMore"]');
		}
		else {
			this.dom.desktopRows.appendChild(desktopFrag);
			this.dom.mobileRows.appendChild(mobileFrag);
		}
		// check for loadmore option
		this.checkForLoadMoreBtn(response);
		this.triggerToResetDefaultForNoResult(isNoResult);
	}

	triggerToResetDefaultForNoResult(isNoResult) { 
		if(isNoResult) {
			const resetDefaultLinks = this.element.querySelectorAll('[data-ref="dynamic-pricing2__resetDefault"]');
			Array.from(resetDefaultLinks).forEach(item => {
				this.addEventListener(item, 'click', () => {
					this.filterIdsClone = [...this.filterIds];
					if(!this.filterIdsClone.length) {
						this.init();
					}
					this.publish('reset-to-default', {dpElement: this.element});
				});
			})
		}
	}

	

	checkForLoadMoreBtn(response) {
		const isMoreRecords = this.records.top + this.records.skip < this.records.total;

		let maxRecords = +this.element.dataset.maxRecords;
		maxRecords = maxRecords || 100;
		if(this.isETFTable && (this.records.top + this.records.skip >= maxRecords)) {
			// show message - refine search and hide show more
			const refineMessage = this.element.querySelector('.etf-refine-message');
			refineMessage.classList.remove('v2-hidden');
			this.dom.loadMore.classList.add('v2-hidden');
		}
		else if (response.HasMoreResults && isMoreRecords) {
			// TODO: add dictionary option to load more
			this.dom.loadMore.classList.remove('v2-hidden');
			this.dom.loadMore.querySelector('.loadMore').classList.remove('v2-hidden');
			const loadMoreTxt = this.dom.loadMore.querySelector('.loadMoreCurCount');
			if (loadMoreTxt) {
				loadMoreTxt.innerText = this.records.skip + this.records.top;
				this.dom.loadMore.querySelector('.loadMoreQuery').innerText = `" ${this.query.current} " `;
				this.dom.loadMore.querySelector('.loadMoreTotalCount').innerText = this.records.total;
			}
		} else {
			this.dom.loadMore && this.dom.loadMore.classList.add('v2-hidden');
		}
	}

	fetchInstrumentRows(url) {
		this.status = 'loding';
		return fetch(url)
			.then(response => {
				if (!response.ok) {
					this.status = 'error';
					throw Error(response.statusText);
				}
				this.status = 'success';
				return response.json();
			})
			.then(responseJson => responseJson);
	}
}
